import React, {useEffect, useState} from "react"
import MaterialButton from "../../../shared/components/MaterialButton";
import {translationKeys} from "../../../localizations/translationKeys-localization";
import {useTranslation} from "react-i18next";
import ImagesContainer from "./ImagesContainer";
import {PREMIUM_ACTION_TYPE} from "../../reducers/premiumReducer";
import {AWS_FOLDER_NAMES, AWS_UPLOAD_TYPE, MEDIA_BASE_URL} from "../utils/aws";
import {getDataFromUrl} from "../../../shared/utils/sash-v2-api";
import {useDispatch, useSelector} from "react-redux";
import UploadLimitReachedModalDialog from "../../../shared/components/UploadLimitReachedModialDialog";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import {PremiumJSON} from "../../../shared/utils/helper";
import {APP_ACTION_TYPE} from "../../reducers/appReducer";
import QuestionAttachmentComponent from "../../../form/components/questions/QuestionAttachmentComponent";
import {ATTACHMENT_TYPE} from "../../../shared/utils/constants";
import closePng from "../../../../public/images/close.png";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import continueButton from "../../../../public/images/icons/builder/undo_button.svg";
import submitButton from "../../../../public/images/icons/builder/submit_gray_tick_mark.svg";
import sectionIcon from "../../../../public/images/icons/builder/section_black_icon.svg";
import useQuestionMgr from "../../hooks/useQuestionMgr";
import useLogicJumpMgr from "../../hooks/useLogicJumpMgr";
import MaterialSwitch from "../../../shared/components/MaterialSwitch";
import {BUILDER_ACTION_TYPE} from "../../reducers/builderReducer";
import {ListManager} from "react-beautiful-dnd-grid";
import ChoiceQuestionCorrectAnswerAndMarks from "./ChoiceQuestionCorrectAnswerAndMarks";
import useChoiceMgr from "../../hooks/useChoiceMgr";

const PictureBody = (props) => {
    const {t} = useTranslation()
    const [imageURL, setImageURL] = useState('')
    const [showMyImages, setShowMyImages] = useState(false)
    const [showAddImage, setShowAddImage] = useState(false)
    const [logicEnabled, setLogicEnabled] = useState(false)
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [selectedAnswerImage, setSelectedAnswerImage] = useState(props.question?.choices?.find(item => item.is_answer)?.image_url)
    const [showImageLimitReached, setShowImageLimitReached] = useState(false)
    const formData = useSelector(state => state.appReducer.formData)
    const currentUserId = useSelector(state => state.userReducer?.userId)
    const showShared = useSelector(state => state.appDashboardReducer.showShared)
    const subscriptionData = useSelector(state => state.userReducer?.subscriptionData)
    const maxQuestionAttachmentUploadLimit = PremiumJSON[subscriptionData?.subscription_plan]?.question_attachments
    const showLogicJumpBasedOnUser = showShared ? PremiumJSON[subscriptionData?.subscription_plan]?.logic_jump && PremiumJSON[formData?.subscription_data?.current_subscription?.plan]?.logic_jump : PremiumJSON[subscriptionData?.subscription_plan]?.logic_jump
    const encodedUserId = btoa(currentUserId)
    const dispatch = useDispatch()

    const {
        questionRequiredChanged,
        questionOtherOptionChanged,
        questionOtherOptionDisabled
    } = useQuestionMgr()
    const {
        addLogicJumpToQuestion,
        addTargetQuestionId,
        generateUniqueString,
        addLogicQuestionId,
        removeLogic,
        selectTargetForTextQuestion
    } = useLogicJumpMgr()
    const {
        addShufflerOptionsForChoiceQuestion
    } = useChoiceMgr()

    useEffect(() => {
        setLogicEnabled(props.question.is_logic_enabled);
    }, [props.question.is_logic_enabled]);

    const addLogicForChoiceQuestion = (index, checkedStatus) => {
        questionRequiredChanged(index, checkedStatus)
        questionOtherOptionChanged(index, checkedStatus)
        questionOtherOptionDisabled(index, checkedStatus)
        addLogicJumpToQuestion(index, checkedStatus)
        setLogicEnabled(checkedStatus)
        if (!checkedStatus) {
            selectTargetForTextQuestion(index, '0')
            removeLogic(index)
            setSelectedQuestions([])
        }
    }

    const handleAddPictureClick = () => {
        props.refQuestionCard.current.style.transform = 'none'
        props.refQuestionCard.current.classList.add('builder-add-image-popup-on-top')
        setShowMyImages(true)
    }

    const onShowAddImage = () => {
        // Check to see if Image upload limit has been reached.
        const successFunction = res => {
            if (encodedUserId === 'dGVtcGxhdGVzQHN1cnZleWhlYXJ0LmNvbQ==') {
                setShowImageLimitReached(false)
                setShowMyImages(false)
                setShowAddImage(true)
            } else if (res.data.form_images.length >= maxQuestionAttachmentUploadLimit) {
                dispatch({type: PREMIUM_ACTION_TYPE.SET_SHOW_UPGRADE_PLAN_POP_UP, payload: true})
            } else {
                setShowMyImages(false)
                setShowAddImage(true)
            }
        }

        const failureFunction = err => {
            setShowMyImages(false)
            setShowAddImage(true)
            console.log(err)
        }

        const requestUrl = `${MEDIA_BASE_URL}/${AWS_FOLDER_NAMES.USERS_JSON_FOLDER}/${props.userId}.json?id=${new Date().getTime()}`
        getDataFromUrl(requestUrl, successFunction, failureFunction)
    }

    const onHideMyImages = () => {
        setQuestionContainerUItoNonFocusedState()
        setShowAddImage(false)
        setShowMyImages(false)
    }

    const onImageAdded = (newImage) => {
        setQuestionContainerUItoNonFocusedState()
        setImageURL(newImage)
        setShowMyImages(false)
        const updatedFormData = {...formData}
        updatedFormData.pages[0].questions[props.index].choices.push({
            image_url: newImage
        })
        dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
    }

    const handleCloseImage = (e) => {

        if (e) {
            e.nativeEvent.stopImmediatePropagation()
        }

        setImageURL(null)
        setShowMyImages(false)
    }


    function getQuestionAttachmentWithImage() {
        return (
            <div>
                <div className="builder-question-line">
                    <div style={{visibility: 'hidden'}}>{props.number}.</div>
                    <div className='builder-question-text-input'>
                        <QuestionAttachmentComponent
                            key={ATTACHMENT_TYPE.IMAGE.key}
                            attachment={{file_type: ATTACHMENT_TYPE.IMAGE.key, image_url: imageURL}}
                            theme={"classic_theme"}
                            backgroundColorProvided={false}
                            onCloseClick={handleCloseImage}
                            userId={props.userId}
                        />
                    </div>
                    <img src="images/icons/builder/attach_file.svg"
                         alt={'attach'}
                         style={{visibility: 'hidden'}}/>
                </div>
            </div>
        )
    }

    const setQuestionContainerUItoNonFocusedState = () => {
        props.refQuestionCard.current.style.transform = 'translate3d(0, 0, 0)'
        props.refQuestionCard.current.classList.remove('builder-add-image-popup-on-top')
        props.RemoveFocusFromQuestionCardUI()
    }

    const handleDragEnd = (source, destination) => {
        const updatedItems = [...props.question.choices];
        let originalFormData = {...props.formData};
        const [reorderedItem] = updatedItems.splice(source, 1);
        updatedItems.splice(destination, 0, reorderedItem);
        const index = originalFormData.pages[0].questions.findIndex(obj => obj._id === props.question._id);
        if (index !== -1) {
            originalFormData.pages[0].questions[index].choices = updatedItems;
        }
        dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: originalFormData})
    }

    const handleJumpToQuestion = (choiceIndex, targetQuestionIndex) => {
        const newSelectedValues = [...selectedQuestions];
        newSelectedValues[choiceIndex] = targetQuestionIndex;
        setSelectedQuestions(newSelectedValues);
        if (targetQuestionIndex === "0" || targetQuestionIndex === "-1") {
            addLogicQuestionId(props.index, choiceIndex, targetQuestionIndex)
        } else if (props.formData?.pages[0]?.questions[targetQuestionIndex]?.logic_question_id) {
            addLogicQuestionId(props.index, choiceIndex, props.formData.pages[0].questions[targetQuestionIndex].logic_question_id)
        } else {
            const uniqueString = generateUniqueString();
            addTargetQuestionId(targetQuestionIndex, uniqueString);
            addLogicQuestionId(props.index, choiceIndex, uniqueString);
        }
    }

    const switchClicked = () => {
        if (!showLogicJumpBasedOnUser) {
            if (showShared && !PremiumJSON[formData?.subscription_data?.current_subscription?.plan]?.logic_jump) {
                dispatch({type: PREMIUM_ACTION_TYPE.SET_SHOW_FREE_OWNER_POP_UP, payload: true})
            } else {
                dispatch({type: PREMIUM_ACTION_TYPE.SET_SHOW_UPGRADE_PLAN_POP_UP, payload: true})
            }
        } else if (formData.pages[0].questions.length <= 1 || formData.pages[0].questions.length - 1 === props.index) {
            dispatch({type: BUILDER_ACTION_TYPE.SET_BUILDER_MESSAGE, payload: 'Action cannot be performed'});
            dispatch({type: BUILDER_ACTION_TYPE.SET_BUILDER_TOAST_MESSAGE, payload: true})
        }
    }

    const handleCorrectAnswerClick = (currentIndex, answer, e) => {
        if (answer !== '') {
            setSelectedAnswerImage(answer)
            const updatedFormData = {...formData}
            updatedFormData.pages[0].questions[props.index].choices.map((choice, choiceIndex) => {
                choice.is_answer = currentIndex === choiceIndex;
            })
            dispatch({type: APP_ACTION_TYPE.SET_FORM_DATA, payload: updatedFormData})
        }
    }

    return (
        <>
            <div style={{textAlign: "start"}}
                 onMouseLeave={() => dispatch({
                     type: BUILDER_ACTION_TYPE.SET_IS_DRAG_AND_DROP_DISABLED,
                     payload: false
                 })}
                 onMouseEnter={() => dispatch({
                     type: BUILDER_ACTION_TYPE.SET_IS_DRAG_AND_DROP_DISABLED,
                     payload: true
                 })}>
                <div className={"picture-body"}>
                    <ListManager
                        items={props.question.choices}
                        direction={logicEnabled && showLogicJumpBasedOnUser ? "vertical" : "horizontal"}
                        maxItems={logicEnabled && showLogicJumpBasedOnUser ? 1 : 4}
                        render={(choice) => {
                            let choiceIndex = props.question.choices.findIndex(currentChoice => choice.image_url === currentChoice.image_url)
                            let questionNumber = 1
                            return (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex"
                                    }}
                                >
                                    <div style={{
                                        width: '160px',
                                        height: '150px',
                                        margin: '10px',
                                        position: "relative"
                                    }}>
                                        <img
                                            src={choice.image_url}
                                            alt="choice"
                                            style={{width: '100%', height: '100%'}}
                                        />
                                        <div
                                            className={"delete-icon-container center"}
                                            style={{
                                                margin: "5px",
                                                cursor: 'pointer',
                                                background: "none",
                                                position: 'absolute',
                                                top: 0,
                                                left: 0
                                            }}>
                                            {(() => {
                                                if (formData.is_quiz) {
                                                    if (choice.is_answer) {
                                                        return (<img
                                                            src={"../../../images/icons/builder/choice_checked.svg"}
                                                            alt={"Option"}
                                                            style={{width: "25px", height: "25px", cursor: "pointer"}}
                                                            onClick={(e) => handleCorrectAnswerClick(choiceIndex, choice.image_url, e)}
                                                        />)
                                                    }

                                                    if (!choice.is_answer) {
                                                        return (<img
                                                            src={"../../../images/icons/builder/choice_unchecked.svg"}
                                                            alt={"Option"}
                                                            style={{width: "25px", height: "25px", cursor: "pointer"}}
                                                            onClick={(e) => handleCorrectAnswerClick(choiceIndex, choice.image_url, e)}
                                                        />)
                                                    }
                                                }
                                            })()}
                                        </div>
                                        <div
                                            className={"delete-icon-container center"}
                                            style={{
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                top: 0,
                                                right: 0
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (choice.is_answer) {
                                                    setSelectedAnswerImage(null)
                                                }
                                                const updatedFormData = {...formData};
                                                updatedFormData.pages[0].questions[props.index].choices.splice(choiceIndex, 1);
                                                dispatch({
                                                    type: APP_ACTION_TYPE.SET_FORM_DATA,
                                                    payload: updatedFormData
                                                });
                                            }}
                                        >
                                            <img src={closePng} alt="close"/>
                                        </div>
                                    </div>
                                    {logicEnabled && showLogicJumpBasedOnUser ?
                                        <div className={"logic-jump-to-question-container"}
                                             style={{flexBasis: "75%"}}>
                                            <p>{t(translationKeys.jump_to)}</p>
                                            <div className={'choice-body-add-logic-dropdown-container'}
                                                 style={{width: "-webkit-fill-available"}}>
                                                <FormControl variant="standard" sx={{
                                                    m: 1,
                                                    minWidth: 220,
                                                    margin: 0,
                                                    width: '-webkit-fill-available'
                                                }}>
                                                    <Select
                                                        labelId={`select-question-helper-label-${choiceIndex}`}
                                                        id={`select-question-helper-${choiceIndex}`}
                                                        label="Select Question"
                                                        MenuProps={{
                                                            style: {width: '280px'},
                                                        }}
                                                        value={selectedQuestions[choiceIndex] || (props?.question?.choices[choiceIndex]?.target_question_id !== ("0" || "-1") ? props?.formData?.pages[0]?.questions.findIndex((question) => props?.question?.choices[choiceIndex]?.target_question_id === question.logic_question_id) : props?.question?.choices[choiceIndex]?.target_question_id)}
                                                        onChange={(e) => handleJumpToQuestion(choiceIndex, e.target.value)}
                                                    >
                                                        <MenuItem value="0"><span
                                                            className={'logic-jump-question-to-select'}><img
                                                            src={continueButton}
                                                            alt={'continue to next question icon'}/> {t(translationKeys.continue_to_next_question)}</span></MenuItem>
                                                        <MenuItem value="-1"><span
                                                            className={'logic-jump-question-to-select'}><img
                                                            src={submitButton}
                                                            alt={'submit form  icon'}/> {t(translationKeys.submit_form)}</span></MenuItem>
                                                        {props.formData.pages[0].questions.map((object, index) => {
                                                            if (object.type === 'SECTION') {
                                                                return (
                                                                    index > props.index &&
                                                                    (<MenuItem value={index}> <span
                                                                        className={'logic-jump-question-to-select'}><img
                                                                        src={sectionIcon}
                                                                        alt={'section icon'}/> {object.title}</span></MenuItem>))
                                                            } else {
                                                                const questionContent = `${questionNumber}. ${object.title}`;
                                                                questionNumber++;
                                                                return (
                                                                    index > props.index &&
                                                                    (<MenuItem value={index}> <span
                                                                        className={'logic-jump-question-to-select'}>{questionContent}</span></MenuItem>))
                                                            }
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div> : null}
                                </div>)
                        }}
                        onDragEnd={handleDragEnd}
                    />
                </div>
                {props.question?.choices.length < 50 && <MaterialButton handleClick={handleAddPictureClick}
                                                                        data={{
                                                                            title: t(translationKeys.add_picture),
                                                                            customButtonContainerStyle: {
                                                                                borderRadius: '50px'
                                                                            },
                                                                            customButtonTextStyle: {
                                                                                fontFamily: 'Nunito Sans, Sans-serif, serif',
                                                                                fontSize: '14px'
                                                                            }
                                                                        }}/>
                }
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    {/*Logic Jump Button*/}
                    {props.isQuiz ? null :
                        <div style={{display: "flex", paddingLeft: "10px", borderLeft: '1px solid #E0E0E0'}}>
                            <div id={'choice-body-add-logic-option'} className="choice-body-add-logic-jump-option">
                                {t(translationKeys.add_logic)}
                            </div>
                            <div onClick={switchClicked} style={{cursor: "pointer"}}>
                                <MaterialSwitch
                                    index={props.index}
                                    initialCheckedState={props.question.is_logic_enabled}
                                    switchChanged={addLogicForChoiceQuestion}
                                    customStyle={(props.formData?.pages[0].questions.length <= 1 || props.formData?.pages[0].questions.length - 1 === props.index) ? {cursor: 'not-allowed'} : null}
                                    isSwitchDisabled={(props.formData?.pages[0].questions.length <= 1 || props.formData?.pages[0].questions.length - 1 === props.index) || !showLogicJumpBasedOnUser}
                                />
                            </div>
                        </div>}
                    {/*Shuffle Options Button*/}
                    <div style={{display: "flex", paddingLeft: "10px", borderLeft: '1px solid #E0E0E0'}}>
                        <div id={'choice-body-add-other-option'} className="choice-body-add-other-option">
                            {t(translationKeys.shuffle_options)}
                        </div>
                        <MaterialSwitch
                            index={props.index}
                            initialCheckedState={props.question.is_options_shuffled}
                            switchChanged={addShufflerOptionsForChoiceQuestion}
                        />
                    </div>
                </div>
            </div>
            {(() => {
                if (formData.is_quiz) {
                    return (<ChoiceQuestionCorrectAnswerAndMarks
                        index={props.index}
                        selectedAnswerImage={selectedAnswerImage}
                        marks={props.question.marks}
                        updateAnswers={props.updateAnswers}
                    />)
                }
            })()}
            <div>
                {
                    (() => {
                        const popUpStyle = {
                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            width: '100%',
                            zIndex: 7,
                            top: '0',
                            left: '0',
                            position: 'fixed',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            margin: '0',
                            padding: '0',
                            height: '100%'
                        }
                        if (showMyImages)
                            return (
                                <div style={popUpStyle}>
                                    <ImagesContainer
                                        showAddImage={onShowAddImage}
                                        hideMyImages={onHideMyImages}
                                        updateChosenTheme={onImageAdded}
                                        userId={props.userId}/>
                                </div>
                            )
                        if (showAddImage)
                            return (
                                <React.Fragment>
                                    <PopUpContainer zIndex={11}
                                                    isImageUploader={true}
                                                    shouldFileBrowserBeVisible={() => {
                                                        setQuestionContainerUItoNonFocusedState()
                                                        setShowAddImage(false)
                                                    }}
                                                    addImage={onImageAdded}
                                                    uploadType={AWS_UPLOAD_TYPE.FORM}
                                                    userId={props.userId}
                                    />
                                    <div style={{display: imageURL === null ? 'none' : 'block'}}>
                                        {getQuestionAttachmentWithImage()}
                                    </div>
                                </React.Fragment>
                            )
                    })()
                }
            </div>
            {
                (() => {
                        if (showImageLimitReached) {
                            return (
                                <UploadLimitReachedModalDialog OKAction={() => setShowImageLimitReached(false)}/>
                            )
                        }
                    }
                )()
            }
        </>
    )
}

export default PictureBody
